import { api } from "../api";

export interface BetaStatus {
  /** Включён ли гейт вообще. Если false — юзеру ничего вводить не нужно. */
  enabled: boolean;
  /** Активировал ли текущий юзер валидный код. */
  redeemed: boolean;
}

/**
 * Спрашиваем у бэка статус закрытого бета-теста для текущего пользователя.
 * Вызывается один раз при старте WebApp — если {enabled:true, redeemed:false},
 * фронт рендерит `BetaGate` вместо основного интерфейса и онбординга.
 */
export async function getBetaStatus(): Promise<BetaStatus> {
  const { data } = await api.get<BetaStatus>("/beta/status");
  return data;
}

/**
 * Активация инвайт-кода. При успехе возвращает {enabled:true, redeemed:true},
 * и `BetaGate` пропускает юзера в приложение.
 */
export async function redeemBetaCode(code: string): Promise<BetaStatus> {
  const { data } = await api.post<BetaStatus>("/beta/redeem", { code });
  return data;
}
